import { StateMachine } from '../StateMachine';

import Init from './Init';
import Authenticating from './Authenticating';
import Authenticated from './Authenticated';
import Unauthenticated from './Unauthenticated';
import Connecting from './Connecting';
import Connected from './Connected';
import Ready from './Ready';
import Default from './Default';

import Closed from './Closed';

const INIT = 'INIT';
const AUTHENTICATING = 'AUTHENTICATING';
const AUTHENTICATED = 'AUTHENTICATED';
const UNAUTHENTICATED = 'UNAUTHENTICATED';
const CONNECTING = 'CONNECTING';
const CONNECTED = 'CONNECTED';
const READY = 'READY';
const CLOSED = 'CLOSED';

export const stateList = [
  { name: INIT, transitions: [AUTHENTICATING], component: Init },
  {
    name: AUTHENTICATING,
    transitions: [AUTHENTICATED, UNAUTHENTICATED],
    component: Authenticating,
  },
  { name: AUTHENTICATED, transitions: [CONNECTING], component: Authenticated },
  {
    name: UNAUTHENTICATED,
    transitions: [AUTHENTICATED],
    component: Unauthenticated,
  },
  { name: CONNECTING, transitions: [CONNECTED], component: Connecting },
  { name: CONNECTED, transitions: [READY], component: Connected },
  { name: READY, transitions: [READY, CLOSED], component: Ready },
  { name: CLOSED, transitions: [AUTHENTICATING], component: Closed },
  { name: 'eslint friendly', transitions: [], component: Default },
];

export default new StateMachine(INIT, stateList);
